module.exports = __webpack_public_path__ + "img/hk-active.0b58c287.png";